import { baseApi } from './baseSplit';
import {
    GET_TOKEN,
    UPDATE_CANCEL_LOGISTIC_JOB_STATUS,
    WEB_API_KEY,
    CANCEL_BOOKING,
    GET_TEXT_FREE_ADDRESSES,
    GET_LOCATION,
} from '../../globals';

const header = {
    'Ocp-Apim-Subscription-Key': WEB_API_KEY,
};

const accountEndPoints = baseApi.injectEndpoints({
    endpoints: (build) => ({
        getAdminAuthToken: build.mutation({
            query: (request) => ({
                url: GET_TOKEN,
                method: 'POST',
                headers: {
                    ...header,
                    'Content-Type': 'text/plain',
                },
                body: 'grant_type=password&username=' + request.email + '&password=' + request.password,
            }),
        }),
        updateOnfleetJobStatus: build.mutation({
            query: (data) => ({
                url: UPDATE_CANCEL_LOGISTIC_JOB_STATUS,
                method: 'POST',
                headers: {
                    ...header,
                    Authorization: data.token,
                },
                body: data.request,
            }),
        }),
        cancelBooking: build.mutation({
            query: (data) => ({
                url: CANCEL_BOOKING,
                method: 'POST',
                headers: {
                    ...header,
                    Authorization: data.token,
                },
                body: data.request,
            }),
        }),
        fetchAddresses: build.mutation({
            query: ({ value, countryCode, container, signal }) => ({
                url: GET_TEXT_FREE_ADDRESSES,
                method: 'POST',
                headers: {
                    ...header,
                },
                params: {
                    Key: 'KU54-HR99-HU89-EG38',
                    Text: value,
                    Countries: countryCode,
                    Language: 'en',
                    Container: container ?? '',
                },
                signal,
            }),
            transformResponse: (response: any) => ({
                Items: response.Items.filter(
                    (i) =>
                        i.Type === 'Address' ||
                        i.Type === 'Street' ||
                        i.Type === 'Postcode' ||
                        i.Type === 'BuildingNumber' ||
                        i.Type === 'BuildingName'
                ),
            }),
        }),
        getLocation: build.mutation({
            query: ({ searchId, partialSearch, airportCode }) => ({
                url: GET_LOCATION,
                method: 'POST',
                headers: {
                    ...header,
                },
                body: {
                    locationProvider: 3,
                    locationType: 4,
                    searchId,
                    partialSearch,
                    airportCode,
                },
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetAdminAuthTokenMutation,
    useUpdateOnfleetJobStatusMutation,
    useCancelBookingMutation,
    useFetchAddressesMutation,
    useGetLocationMutation,
} = accountEndPoints;
